var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    d: "M20 5h-2.95a.5.5 0 0 1-.369-.162L15.15 3.162a.5.5 0 0 0-.37-.162H9.22a.5.5 0 0 0-.369.162L7.32 4.838a.5.5 0 0 1-.37.162H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 12.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3.33a.5.5 0 0 0 .369-.162L9.73 5.162a.5.5 0 0 1 .37-.162H13.9a.5.5 0 0 1 .369.162L15.8 6.838a.5.5 0 0 0 .37.162H19.5a.5.5 0 0 1 .5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6.4a2.4 2.4 0 1 1 0-4.801 2.4 2.4 0 0 1 0 4.801"
  })));
};
export default SvgCamera;